import React from "react";
import ReactDOM from "react-dom/client";

import "./theme/tokens.css";
import "./theme/global.css";
import "./localization/i18n";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
